module.exports = __webpack_public_path__ + "c0d1f7ad110442676352bd49da78f978.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_l_50.mp3
// module id = 448
// module chunks = 0